import {handleActions} from 'redux-actions';
import {Record, Set} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Actions from './actions';

const State = Record({
    loading: false,
    behaviors: new BehaviorsCollection(),
    creating: false,
    editIds: Set(),
    updatingIds: Set(),
    showOnChildActivityLocalValue: undefined, // Used to show the state of the feature correctly just after it's been updated
    loadingFeatureForm: false,
});

export default handleActions(
    {
        [Actions.fetch.type]: () => new State({loading: true}),
        [Actions.fetchSuccess.type]: (state, {payload}) => state.merge({loading: false, behaviors: payload.behaviors}),
        [Actions.fetchFailed.type]: state => state.merge({loading: false}),
        [Actions.create.type]: state => state.merge({creating: true}),
        [Actions.createFailed.type]: state => state.merge({creating: false}),
        [Actions.createSuccess.type]: state => state.merge({creating: false}),
        [Actions.edit.type]: (state, {payload}) =>
            state.merge({
                editIds: state.editIds.includes(payload.id)
                    ? state.editIds.delete(payload.id)
                    : state.editIds.add(payload.id),
            }),
        [Actions.update.type]: (state, {payload}) =>
            state.merge({
                updatingIds: state.updatingIds.add(payload.statusConfigId),
            }),
        [Actions.updateSuccess.type]: (state, {payload}) =>
            state.merge({
                editIds: state.editIds.delete(payload.statusConfigId),
                updatingIds: state.updatingIds.delete(payload.statusConfigId),
            }),
        [Actions.updateFailed.type]: (state, {payload}) =>
            state.merge({
                editIds: state.editIds.delete(payload.statusConfigId),
                updatingIds: state.updatingIds.delete(payload.statusConfigId),
            }),
        [Actions.enableHideFromChildActivity.type]: state =>
            state.merge({
                loadingFeatureForm: true,
            }),
        [Actions.enableHideFromChildActivitySuccess.type]: state =>
            state.merge({
                showOnChildActivityLocalValue: false,
                loadingFeatureForm: false,
            }),
        [Actions.enableHideFromChildActivityFailed.type]: state =>
            state.merge({
                loadingFeatureForm: false,
            }),
        [Actions.disableHideFromChildActivity.type]: state =>
            state.merge({
                loadingFeatureForm: true,
            }),
        [Actions.disableHideFromChildActivitySuccess.type]: state =>
            state.merge({
                showOnChildActivityLocalValue: true,
                loadingFeatureForm: false,
            }),
        [Actions.disableHideFromChildActivityFailed.type]: state =>
            state.merge({
                loadingFeatureForm: false,
            }),
    },
    new State(),
);
